import { createStyles, makeStyles, Theme } from 'ui-components';
import { fontText } from 'common-react';

export default makeStyles((theme: Theme) => createStyles({
  ikzeBox: {
    marginBottom: 32,
    width: '100%',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 24,
    },
  },
  fundTitleWrapper: {
    maxWidth: 770,
    margin: '0 auto',
    marginBottom: 12
  },
  fundTitle: {
    font: fontText('normal', theme.fontSize.base, 20),
    color: theme.color.greys[60],
    marginBottom: 8,
  },
}), {name: 'SetAmountsProductSection'});
